module.exports = __webpack_public_path__ + "img/16.278f1a08.png";